<template>
  <div class="componet-slide-funcionarios">
    <div class="anterior">
      <i
        class="pi pi-chevron-left"
        style="font-size: 2rem; color: darkblue"
        @click="this.anterior()"
        :class="{ naoPossuiProxima: !this.possuiPaginaAnterior }"
      ></i>
    </div>

    <div class="dados">
      <ProgressSpinner strokeWidth="5" animationDuration="1" v-if="this.loading" class="p-progress-spinner" />
      <template v-if="!this.loading">
        <div class="" style="display: flex">
          <div style="display: flex; align-items: center">
            <img
              src="https://as2.ftcdn.net/jpg/03/46/93/61/220_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg"
              alt=""
              style="max-width: 80px; border-radius: 45px"
            />
          </div>
          <div style="width: 100%; float: left; padding-left: 15px" v-for="(item, index) in this.items" :key="index">
            <div>
              <span class="descricao nome">{{ item.matricula }} - {{ item.nome }}</span>
            </div>
            <div>
              <span class="descricao">{{ item.sede.descricao }}</span>
            </div>
            <div>
              <span class="descricao">{{ item.cargo.descricao }}</span>
            </div>
            <div>
              <span class="descricao">{{ item.unidadeLotacao.descricao }}</span>
            </div>
            <div>
              <span class="descricao">{{ item.localTrabalho }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="proximo">
      <i class="pi pi-chevron-right" style="font-size: 2rem" @click="this.proximo()" :class="{ naoPossuiProxima: !this.possuiProximaPagina }"></i>
    </div>
  </div>
</template>
<script src="./slide-funcionarios.js"></script>
